'use strict';

var modelsList = function () {
	var _init = function _init(mode) {
		if (typeof listaModelos !== 'undefined' && listaModelos !== '') {
			var jsonList = listaModelos;
			var param = window.location.hash ? window.location.hash : '#actuales';
			_buildLists(jsonList, mode, param);
		} else {
			console.error('lista de modelos no definida o vacía');
		}

		$('.js-selector-modelos').on('click', function (e) {
			// e.preventDefault()
			_toggleSelection($(this).find('a').attr('href'), mode);
		});

		$(window).on('resize', function () {
			_listaMovil();
		});
		_listaMovil();
	};

	var _buildArray = function _buildArray(data) {
		var coches = [];
		for (var i = 0; i < data.length; i++) {
			var value = data[i];
			if (!value.padre || value.actual) {
				var coche = JSON.stringify(value);
				coche = JSON.parse(coche);
				coche.hijos = [];

				for (var _i = 0; _i < data.length; _i++) {
					var _value = data[_i];

					if (_value.padre === coche.moi) {
						coche.hijos.push(_value);
					} else if (_value.moi === coche.moi) {
						coche.hijos.push(_value);
					}
				}
				coches.push(coche);
			}
		}
		return coches;
	};

	var _printParrilla = function _printParrilla($container, $tptElem, list, type, mode, selection) {
		// Control de las pestañas [Actual]-[Todos]
		var selector = selection.replace('#', '.');

		if (typeof list !== 'undefined' && list !== '') {
			$container.empty();
			for (var i = 0; i < list.length; i++) {
				var item = list[i];
				var $domNode = $tptElem.clone().removeAttr('id');
				$domNode.find('a').attr('href', item.link);
				var nombre = item.nombre;
				if (item.padre !== '' && item.padre !== item.moi || !item.actual) {
					nombre = item.nombre + ' <span class="code">(' + item.modelcode + ')</span>';
				}
				$domNode.find('.js-nombre').html(nombre);

				if (type === 2) {
					$domNode.find('.js-carroceria').text(item.carroceria);
				}

				if (mode === 'home') {
					if (item.imagen) {
						$domNode.find('.js-imagen').attr({
							'src': item.imagen,
							'alt': item.nombre
						});
					}
				} else {
					$domNode.find('.js-imagen').remove();
				}

				if (selection === '#todos') $domNode.addClass('todos');
				if (selection === '#todos' && !item.actual) {
					if (!item.padre) $container.append($domNode.addClass('anterior'));
				} else if (item.actual) {
					$container.append($domNode.addClass(item.moi));
				}

				if (item.hijos.length > 1) {
					$container.siblings('.aop-titulo').show();
					for (var _i2 = 0; _i2 < item.hijos.length; _i2++) {
						var item_hijo = item.hijos[_i2];
						var _$domNode = $tptElem.clone().removeAttr('id');
						_$domNode.find('a').attr('href', item_hijo.link);
						if (item_hijo.moi === item.moi) {
							var _nombre = item_hijo.nombre + ' <span class="code">(' + item_hijo.modelcode + ')</span>';
							_$domNode.find('.js-nombre').html(_nombre);
							_$domNode.addClass('hijo actual');
						} else {
							var _nombre2 = item_hijo.nombre + ' <span class="code">(' + item_hijo.modelcode + ')</span>';
							_$domNode.find('.js-nombre').html(_nombre2);
							// $domNode.find('.js-nombre').html(item_hijo.nombre + ' <span>('+item_hijo.modelcode+')</span>')
						}
						if (type === 2) {
							_$domNode.find('.js-carroceria').text(item_hijo.carroceria);
						}
						_$domNode.find('.js-imagen').remove();
						_$domNode.addClass('hijo');
						_$domNode.find('.aop-versiones-anteriores').remove();
						$('.' + item.moi).addClass('padre').find('.versiones').append(_$domNode);
					}
				}
			}

			$('.js-selector-modelos').removeClass('activado');
			$(selector).addClass('activado');

			$('.js-select').off('click').on('click', function (e) {
				e.stopPropagation();
				var estado = $(this).closest('.aop-versiones-anteriores').hasClass('abierto') ? 1 : 0;
				$('.aop-versiones-anteriores.abierto').removeClass('abierto');
				if (!estado) $(this).closest('.aop-versiones-anteriores').addClass('abierto');
			});
			$('body').on('click', function (e) {
				$('.aop-versiones-anteriores.abierto').removeClass('abierto');
			});
			_listaMovil();
		} else {
			console.log('Lista de Turismos o Comerciales no definida o vacía');
		}
	};

	var _toggleSelection = function _toggleSelection($list, mode) {
		var jsonList = listaModelos;
		_buildLists(jsonList, mode, $list);
	};

	var _buildLists = function _buildLists(jsonList, mode, selection) {
		console.log('selection', selection);
		// Turismos
		var $containerTur = $('.js-lista-turismos');
		var $templateTur = $('#js-turismo-template');
		_printParrilla($containerTur, $templateTur, _buildArray(jsonList.turismos), 1, mode, selection);

		// Comerciales
		var $containerCom = $('.js-lista-comerciales');
		var $templateCom = $('#js-comercial-template');
		_printParrilla($containerCom, $templateCom, _buildArray(jsonList.comerciales), 2, mode, selection);
	};

	var _listaMovil = function _listaMovil() {
		if ($(window).width() < 768) {
			$('.padre.activado > a').off('click').on('click', function (e) {
				e.preventDefault();
				var padre = $(this).closest('.padre');
				if (padre.hasClass('abierto')) {
					$('.padre.abierto').removeClass('abierto');
				} else {
					$('.padre.abierto').removeClass('abierto');
					padre.addClass('abierto');
				}
			});
		} else {
			$('.h-submenu .padre.activado > a').off('click').on('click', function (e) {
				e.preventDefault();
				var padre = $(this).closest('.padre');
				if (padre.hasClass('abierto')) {
					$('.padre.abierto').removeClass('abierto');
				} else {
					$('.padre.abierto').removeClass('abierto');
					padre.addClass('abierto');
				}
			});
		}
	};

	return {
		init: _init,
		buildArray: _buildArray
	};
}();